/* eslint-disable react/no-danger */
import moment from 'moment';
import React, { Component } from 'react';
import { RIEInput } from 'riek';
import queryString from 'query-string';
import {
  Button,
  Table,
  Input,
  message,
  Modal,
  Icon,
  Select,
  Popconfirm,
  Alert,
  Progress,
  TreeSelect,
} from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { backendErrorTip } from '../../../../utils';
import columns from './columns';
import xfetch from '../../../../xfetch';
import UpdateForm from './UpdateForm';
import BatchAdd from './BatchAdd';
import s from './style.css';

const { Option } = Select;
const { Search } = Input;
const { TreeNode } = TreeSelect;

@withStyles(s)
export default class Category extends Component {
  constructor(props) {
    super(props);
    this.q = {
      page_size: 10,
      page: 1,
      status__in: 'on,off',
    };
    this.baseApi = `${window.G.backendApi}/knowledge/answer/`;
    this.orgTreeApi = `${window.G.backendApi}/profiles/organization/tree/`;
    this.trainAPi = `${window.G.backendApi}/knowledge/answer/train/`;
    this.baseQsApi = `${window.G.backendApi}/knowledge/question/`;
  }
  state = {
    data: {},
    item: {},
    loading: true,
    modals: {
      updateForm: { title: '', visible: false },
      showSameQuestionsModal: { title: '', visible: false },
      learnProgressModal: { title: '', visible: false },
      batchAddModal: { title: '', visible: false },
    },
    updateItemLoading: false,
    selectedRowKeys: [],
    knowledges: [],
    knowledgeCategories: [],
    trainStatus: 'doing',
    learnProgress: 0,
    learnTotalTime: '',
    treeNodes: [],
  };
  componentDidMount() {
    this.query();
    this.queryFilters();
    this.getTrainStatus();
    this.queryOrgTree();
  }
  onTableChange = (pagination, filters, sorters) => {
    const { field, order } = sorters;
    if (!order) {
      delete this.q.ordering;
    } else {
      this.q.ordering = `${order === 'ascend' ? '' : '-'}${field}`;
    }
    const { current } = pagination;
    this.q.page = current;
    this.query();
  };
  onSelectChange = selectedRowKeys => this.setState({ selectedRowKeys });
  setModals({ key, title, item = {}, visible }) {
    this.setState({
      modals: {
        ...this.state.modals,
        [key]: {
          ...this.state.modals[key],
          title,
          visible,
        },
      },
      item,
    });
  }
  getTrainStatus = async () => {
    const { result: trainStatus = {} } = await xfetch(this.trainAPi);
    return new Promise(resolve => {
      this.setState(
        {
          trainStatus: trainStatus.status,
        },
        () => resolve(trainStatus.status),
      );
    });
  };
  query = async () => {
    const api = `${this.baseApi}?${queryString.stringify(this.q)}`;
    const { error, result } = await xfetch(api);
    this.setState({
      loading: false,
    });
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      data: result,
    });
  };
  queryFilters = async () => {
    const knowledgeApi = `${window.G.backendApi}/knowledge/knowledge/options/?staus=on`;
    const knowledgeCategoryApi = `${window.G.backendApi}/knowledge/knowledge_category/options/?status=on`;
    const { result: knowledges } = await xfetch(knowledgeApi);
    const { result: knowledgeCategories } = await xfetch(knowledgeCategoryApi);
    this.setState({
      knowledges,
      knowledgeCategories,
    });
  };
  queryOrgTree = async () => {
    const { error, result } = await xfetch(this.orgTreeApi);
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      treeNodes: result.tree,
    });
  };
  forceQuery = () => {
    this.q.page = 1;
    this.q.search = '';
    this.query();
  };
  addQuestion = (answer, title) =>
    xfetch(this.baseQsApi, {
      method: 'POST',
      body: {
        answer,
        title,
      },
    });
  updateQuestion = (answer, questionId, title) =>
    xfetch(`${this.baseQsApi}${questionId}/`, {
      method: 'PATCH',
      body: {
        answer,
        title,
      },
    });
  updateItem = () => {
    let title;
    const { item } = this.state;
    const { id: answerId } = item;

    this.setState({
      updateItemLoading: true,
    });
    this.updateForm.validateFields(async (err, values) => {
      if (err) {
        this.setState({
          updateItemLoading: false,
        });
        return;
      }
      const {
        questionTitle,
        knowledge,
        knowledge_category: knowledgeCategory,
        status,
        content,
        organization,
        content_type: contentType,
        hot_place, // eslint-disable-line
        hot_index, // eslint-disable-line
        timeout,
      } = values;

      if (!content) {
        message.warn('答案不能为空');
        this.setState({
          updateItemLoading: false,
        });
        return;
      }
      if (answerId) {
        title = '编辑问题';
        // 1. 先更新答案
        const { error, result } = await xfetch(`${this.baseApi}${answerId}/`, {
          body: {
            status: status ? 'on' : 'off',
            hot_index,
            hot_place,
            knowledge,
            content,
            organization,
            timeout: moment(timeout).format('YYYY-MM-DD 00:00:00'),
            content_type: contentType,
            knowledge_category: knowledgeCategory,
          },
          method: 'PATCH',
        });
        if (error) {
          this.setState({
            updateItemLoading: false,
          });
          backendErrorTip(error);
          return;
        }

        // 3. 再更新答案的标准问法
        const { error: error3 } = await this.updateQuestion(
          answerId,
          result.questions[0].id,
          questionTitle,
        );
        if (error3) {
          backendErrorTip(error3);
          this.setState({
            updateItemLoading: false,
          });
          return;
        }

        this.setState({
          updateItemLoading: false,
        });
        this.setModals({
          key: 'updateForm',
          title,
          visible: false,
        });
        message.success('编辑成功');
        this.query();
      } else {
        title = '添加问题';
        // 先添加答案
        const { error, result } = await xfetch(this.baseApi, {
          body: {
            status: status ? 'on' : 'off',
            knowledge,
            knowledge_category: knowledgeCategory,
            content,
            organization,
            content_type: contentType,
            hot_index,
          },
          method: 'POST',
        });
        if (error) {
          this.setState({
            updateItemLoading: false,
          });
          backendErrorTip(error);
          return;
        }
        // 2. 再添加答案的标准问法
        const { error: error2 } = await this.addQuestion(
          result.id,
          questionTitle,
        );
        if (error2) {
          backendErrorTip(error2);
          this.setState({
            updateItemLoading: false,
          });
          return;
        }
        this.setState({
          updateItemLoading: false,
        });
        this.setModals({
          key: 'updateForm',
          title,
          visible: false,
        });
        message.success('添加成功');
        this.query();
      }
    });
  };
  addSameQuestionHolder = () => {
    const { questions } = this.state.item;
    this.setState({
      item: {
        ...this.state.item,
        questions: [
          ...questions,
          { id: `NEWQS${questions[questions.length - 1].id + 1}`, title: '' },
        ],
      },
    });
  };
  editSameQustion = async (answer, questionId, value) => {
    const nextQuestions = this.state.item.questions.map(question =>
      question.id === questionId
        ? {
            ...question,
            title: value,
          }
        : question,
    );
    // 新增相似问题
    if (String(questionId).indexOf('NEWQS') !== -1) {
      const { error, result } = await xfetch(this.baseQsApi, {
        method: 'POST',
        body: {
          answer,
          title: value,
        },
      });
      if (error) {
        backendErrorTip(error);
      }
      this.setState({
        item: {
          ...this.state.item,
          questions: nextQuestions.map(x =>
            questionId === x.id ? { ...x, id: result.id } : x,
          ),
        },
      });
    } else {
      // 编辑相似问题
      const { error } = await xfetch(`${this.baseQsApi}${questionId}`, {
        method: 'PATCH',
        body: {
          answer,
          title: value,
        },
      });
      if (error) {
        backendErrorTip(error);
      }
      this.setState({
        item: {
          ...this.state.item,
          questions: nextQuestions,
        },
      });
    }
    this.query();
  };
  // 删除相似问题
  removeSameQuestion = async questionId => {
    const { questions } = this.state.item;
    const nextQuestions = questions.filter(x => x.id !== questionId);
    this.setState({
      item: {
        ...this.state.item,
        questions: nextQuestions,
      },
    });
    await xfetch(`${this.baseQsApi}${questionId}`, {
      method: 'DELETE',
    });
    this.query();
  };
  showSameQuestions = item =>
    this.setModals({
      item,
      key: 'showSameQuestionsModal',
      title: '相似问题',
      visible: true,
    });
  showAnswer = content => {
    Modal.info({
      title: '答案详情',
      width: 600,
      content: (
        <div
          className={s.answer}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      ),
      onOk() {},
    });
  };
  handleChangeItem = item => this.setState({ item });
  handleSearch = search => {
    this.q.search = search;
    this.q.page = 1;
    this.query();
  };
  triggerStatus = async (id, status) => {
    const nextStatus = status === 'on' ? 'off' : 'on';
    const { error } = await xfetch(`${this.baseApi}${id}/`, {
      body: {
        status: nextStatus,
      },
      method: 'PATCH',
    });
    if (!error) {
      this.setState({
        data: {
          ...this.state.data,
          results: this.state.data.results.map(x =>
            x.id === id
              ? {
                  ...x,
                  status: nextStatus,
                }
              : x,
          ),
        },
      });
    }
  };
  handleTrain = async () => {
    this.setState({
      trainStatus: 'doing',
    });
    const { modals } = this.state;
    const { error, result } = await xfetch(this.trainAPi, {
      method: 'POST',
    });
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState(
      {
        learnProgress: 1,
        learnTotalTime: result.total_time,
        modals: {
          ...modals,
          learnProgressModal: {
            visible: true,
            title: '正在学习',
          },
        },
      },
      () => {
        this.timer = setInterval(async () => {
          const { learnProgress } = this.state;
          if (learnProgress < 100 && learnProgress > 90) {
            const status = await this.getTrainStatus();
            if (status === 'doing') {
              return;
            }
          }
          if (learnProgress >= 100) {
            message.success('学习完成');
            this.setState({
              trainStatus: 'idle',
            });
            clearInterval(this.timer);
            this.setState({
              modals: {
                ...modals,
                learnProgressModal: {
                  visible: false,
                  title: '正在学习',
                },
              },
            });
            return;
          }
          this.setState({
            learnProgress: Math.ceil(learnProgress + 100 / result.total_time),
          });
        }, 1000);
      },
    );
  };
  deleteItem = async id => {
    await xfetch(`${this.baseApi}${id}/`, {
      method: 'PATCH',
      body: { status: 'deleted' },
    });
    this.query();
  };
  batchDelete = async () => {
    const { selectedRowKeys: ids } = this.state;
    const { error } = await xfetch(
      `${this.baseApi}batch_delete/?ids=${JSON.stringify(ids)}`,
      {
        method: 'DELETE',
      },
    );
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.q.page = 1;
    this.search = '';
    this.query();
  };
  renderTreeNodes = tree => {
    const data = Object.values(tree);
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode
            disabled={item.deprecated}
            key={item.id}
            value={item.id}
            title={item.name}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          value={item.id}
          disabled={item.deprecated}
          title={item.name}
        />
      );
    });
  };
  render() {
    const {
      data: { results, count = 0 },
      loading,
      item,
      modals: {
        updateForm,
        showSameQuestionsModal,
        batchAddModal,
        learnProgressModal,
      },
      selectedRowKeys,
      updateItemLoading,
      knowledges,
      knowledgeCategories,
      trainStatus,
      learnProgress,
      learnTotalTime,
      treeNodes,
    } = this.state;
    const orgTreeNodes = this.renderTreeNodes(treeNodes);
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const pagination = {
      pageSize: 10,
      total: count,
      showTotal: t => `共 ${t} 条`,
      current: this.q.page,
    };
    return (
      <div className={s.wrap}>
        <Alert
          message="提示：修改问题、添加相似问题、删除相似问题需要机器人重新学习后生效。"
          type="warning"
          closable
          style={{ marginBottom: 15 }}
        />
        <div className={s.toolbar}>
          <div className={s.toolbarLeft}>
            <span className={s.toolbarField}>
              <span className={s.toolbarLabel}>知识点：</span>
              <Select
                showSearch
                dropdownMatchSelectWidth
                placeholder="请选择"
                style={{ width: 140 }}
                filterOption={(inputValue, option) =>
                  option.props.children.indexOf(inputValue) > -1
                }
                onChange={v => {
                  this.q.knowledge = v;
                  this.q.page = 1;
                  this.query();
                }}
              >
                <Option value="">全部</Option>
                {knowledges.map(x => (
                  <Option value={x.id}>{x.title}</Option>
                ))}
              </Select>
            </span>
            <span className={s.toolbarField}>
              <span className={s.toolbarLabel}>所属分类：</span>
              <Select
                showSearch
                dropdownMatchSelectWidth
                placeholder="请选择"
                style={{ width: 140 }}
                filterOption={(inputValue, option) =>
                  option.props.children.indexOf(inputValue) > -1
                }
                onChange={v => {
                  this.q.knowledge_category = v;
                  this.q.page = 1;
                  this.query();
                }}
              >
                <Option value="">全部</Option>
                {knowledgeCategories.map(x => (
                  <Option value={x.id}>{x.title}</Option>
                ))}
              </Select>
            </span>
            <span className={s.toolbarField}>
              <span className={s.toolbarLabel}>组织机构：</span>
              <TreeSelect
                showSearch
                style={{ width: 140 }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="请选择"
                allowClear
                onChange={organization => {
                  this.q.organization = organization;
                  this.q.page = 1;
                  this.query();
                }}
                treeDefaultExpandAll
              >
                {orgTreeNodes}
              </TreeSelect>
            </span>
            <span className={s.toolbarField}>
              <span className={s.toolbarLabel}>学习状态：</span>
              <Select
                showSearch
                dropdownMatchSelectWidth
                placeholder="请选择"
                style={{ width: 140 }}
                filterOption={(inputValue, option) =>
                  option.props.children.indexOf(inputValue) > -1
                }
                onChange={v => {
                  this.q.train_status = v;
                  this.q.page = 1;
                  this.query();
                }}
              >
                <Option value="">全部</Option>
                <Option value="todo">待学习</Option>
                <Option value="done">已学习</Option>
                <Option value="unable">无法学习</Option>
              </Select>
            </span>
            <span className={s.toolbarField} style={{ margin: 0 }}>
              <span className={s.toolbarLabel}>位置：</span>
              <Select
                showSearch
                dropdownMatchSelectWidth
                placeholder="请选择"
                style={{ width: 94 }}
                filterOption={(inputValue, option) =>
                  option.props.children.indexOf(inputValue) > -1
                }
                onChange={v => {
                  this.q.hot_place = v;
                  this.q.page = 1;
                  this.query();
                }}
              >
                <Option value="">全部</Option>
                <Option value="left_top">左</Option>
                <Option value="right_top">右</Option>
              </Select>
            </span>
          </div>
        </div>
        <div className={s.toolbar}>
          <div className={s.toolbarLeft}>
            <Search
              placeholder="输入问题标题搜索"
              onSearch={this.handleSearch}
              style={{ width: 260 }}
              enterButton="搜索"
            />
          </div>
          <div className={s.toolbarRight}>
            <Popconfirm
              title="学习时会占用较多服务器资源。确认重新学习？"
              okText="确认"
              cancelText="取消"
              onConfirm={this.handleTrain}
            >
              <Button disabled={trainStatus === 'doing'} type="danger">
                重新学习
              </Button>
            </Popconfirm>
            <Button
              type="primary"
              onClick={() =>
                this.setModals({
                  key: 'batchAddModal',
                  title: '批量导入问题',
                  visible: true,
                })
              }
            >
              批量导入
            </Button>
            <Button
              onClick={() =>
                this.setModals({
                  item: {},
                  key: 'updateForm',
                  title: '添加问题',
                  visible: true,
                })
              }
            >
              添加
            </Button>
            {selectedRowKeys.length ? (
              <Popconfirm
                title="确认批量删除？"
                placement="left"
                okText="确认"
                cancelText="取消"
                onConfirm={this.batchDelete}
              >
                <Button type="danger">删除</Button>
              </Popconfirm>
            ) : (
              <Button type="danger" disabled>
                删除
              </Button>
            )}
          </div>
        </div>
        <div className={s.table}>
          <Table
            rowKey="id"
            scroll={{ x: true }}
            loading={loading}
            dataSource={results}
            columns={columns(this, s)}
            rowSelection={rowSelection}
            pagination={pagination}
            onChange={this.onTableChange}
          />
        </div>
        <Modal
          title={updateForm.title}
          visible={updateForm.visible}
          width={800}
          maskClosable={false}
          destroyOnClose
          confirmLoading={updateItemLoading}
          onOk={this.updateItem}
          onCancel={() =>
            this.setModals({
              key: 'updateForm',
              title: '',
              visible: false,
            })
          }
          className={s.updateGroupForm}
        >
          <UpdateForm
            ref={x => {
              this.updateForm = x;
            }}
            orgTreeNodes={orgTreeNodes}
            changeItem={this.handleChangeItem}
            knowledges={knowledges}
            knowledgeCategories={knowledgeCategories}
            item={item}
          />
        </Modal>
        <Modal
          title="查看相似问题"
          destroyOnClose
          maskClosable={false}
          width={600}
          visible={showSameQuestionsModal.visible}
          onOk={() =>
            this.setModals({
              key: 'showSameQuestionsModal',
              title: '',
              visible: false,
            })
          }
          onCancel={() =>
            this.setModals({
              key: 'showSameQuestionsModal',
              title: '',
              visible: false,
            })
          }
        >
          <div>
            {item.questions &&
              item.questions.slice(1).map((question, i) => (
                <div className={s.question} key={question.id}>
                  <span className={s.order}>{i + 1}. </span>
                  <RIEInput
                    className="g-input-edit"
                    classEditing="g-input-editing"
                    value={question.title || '点击输入'}
                    propName="describe"
                    change={({ describe }) =>
                      this.editSameQustion(item.id, question.id, describe)
                    }
                  />
                  <span className={s.qsBar}>
                    <Popconfirm
                      title="确认删除？"
                      placement="right"
                      okText="确认"
                      cancelText="取消"
                      onConfirm={() => this.removeSameQuestion(question.id)}
                    >
                      <Icon type="delete" />
                    </Popconfirm>
                  </span>
                </div>
              ))}
            <div className={s.addBar}>
              <Button icon="plus" onClick={() => this.addSameQuestionHolder()}>
                添加相似问题
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          title="批量导入问题"
          destroyOnClose
          maskClosable={false}
          width={400}
          visible={batchAddModal.visible}
          onOk={() =>
            this.setModals({
              key: 'batchAddModal',
              title: '',
              visible: false,
            })
          }
          onCancel={() =>
            this.setModals({
              key: 'batchAddModal',
              title: '',
              visible: false,
            })
          }
        >
          <BatchAdd query={this.forceQuery} />
        </Modal>
        <Modal
          title="正在学习..."
          destroyOnClose
          maskClosable={false}
          footer={null}
          width={400}
          visible={learnProgressModal.visible}
          onCancel={() =>
            this.setModals({
              key: 'learnProgressModal',
              title: '',
              visible: false,
            })
          }
        >
          <div>
            <div className={s.learnProgressTitle}>
              本次学习预计需要 {learnTotalTime} 秒，请稍后...
            </div>
            <Progress percent={learnProgress} status="active" />
          </div>
        </Modal>
      </div>
    );
  }
}
